export const managementCourse = [
    {
        id: 1,
        title: "美业新趋势（论坛分享）",
        description: "",
        type: "offline",
        instructor: {
            id: "datin",
            name: "Datin Winnie Loo, Dato Dr. Denming Ho, Dato Dr Gavin Voon, Nico Tan, Darren Soo",
            avatar: "",
            rating: 4.9,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "Youtube Private Link",
        image: "/images/management/1.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "Pls Ask",
        seats: "Limited to 15 participants"
    },
    {
        id: 2,
        title: "美业学习峰会",
        description: "",
        type: "offline",
        instructor: {
            id: "darren",
            name: "Darren Soo, Dato Keen, Dya Chua",
            avatar: "",
            rating: 4.8,
        },
        date: " ",
        time: "TBC",
        venue: "Youtube Private Link",
        image: "/images/management/2.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 2940",
        seats: "Only 10 spots available"
    },
    {
        id: 3,
        title: "美业门店管理",
        description: "",
        type: "offline",
        instructor: {
            id: "darren",
            name: "Darren Soo",
            avatar: "",
            rating: 5.0,
        },
        date: "4-6 Aug 2025",
        time: "TBC",
        venue: "KL",
        image: "/images/management/3.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 4980",
        seats: ""
    },
    {
        id: 4,
        title: "美业流量变现",
        description: "",
        type: "offline",
        instructor: {
            id: "hai2",
            name: "海老师(中国)",
            avatar: "",
            rating: 4.7,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "KL",
        image: "/images/management/4.jpeg",
        registrationUrl: "/#",
        price: "Pls Ask for Special Price",
        seats: "Limited enrollment"
    },
    {
        id: 5,
        title: "人性密码",
        description: "",
        type: "offline",
        instructor: {
            id: "hai",
            name: "海老师(中国)",
            avatar: "",
            rating: 4.8,
        },
        date: " ",
        time: "TBC",
        venue: "KL",
        image: "/images/management/5.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 6980",
        seats: "Only 10 spots available"
    },
    {
        id: 6,
        title: "头疗店运营",
        description: "",
        type: "offline",
        instructor: {
            id: "tanzhang",
            name: "探长导师(台湾）",
            avatar: "",
            rating: 5.0,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "KL",
        image: "/images/management/6.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 399",
        seats: ""
    },
    {
        id: 7,
        title: "领导人",
        description: "",
        type: "offline",
        instructor: {
            id: "menglan",
            name: "梦兰老师(M), 惠乾老师(M)",
            avatar: "",
            rating: 5.0,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "",
        image: "/images/management/7.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 399",
        seats: ""
    }
]
// Helper function to get upcoming courses
export const getCourse = () => {
    const now = new Date()
    return managementCourse.filter(course => new Date(course.date) > now)
}